/**
 * Componente para proteger rutas privadas
 * Redirige a login si no hay sesión activa
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * PrivateRoute - HOC para proteger rutas
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componente a renderizar si está autenticado
 * @param {number[]} props.allowedRoles - Roles permitidos (opcional)
 * @param {boolean} props.checkTipoUsuario - Si debe verificar tipoUsuario en lugar de IdRol
 */
const PrivateRoute = ({ children, allowedRoles = [], checkTipoUsuario = false }) => {
  const location = useLocation();
  
  const userStr = localStorage.getItem('user');
  
  console.log('🔒 PrivateRoute check:', { 
    path: location.pathname, 
    hasUser: !!userStr,
    allowedRoles,
    checkTipoUsuario
  });
  
  // No hay sesión (solo verificar user, no token)
  if (!userStr) {
    console.log('❌ No user found, redirecting to /');
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  
  // Verificar roles si se especificaron
  if (allowedRoles.length > 0) {
    try {
      const user = JSON.parse(userStr);
      console.log('👤 User data:', user);
      
      // Para admin, verificar tipoUsuario; para otros, verificar IdRol
      const roleToCheck = checkTipoUsuario ? user?.tipoUsuario : user?.IdRol;
      
      console.log('🎯 Role check:', { roleToCheck, allowedRoles, checkTipoUsuario });
      
      if (!allowedRoles.includes(roleToCheck)) {
        console.log('❌ Role not allowed, redirecting to /home');
        // Redirigir a home si no tiene el rol requerido
        return <Navigate to="/home" replace />;
      }
    } catch (err) {
      console.error('❌ Error parsing user:', err);
      return <Navigate to="/" replace />;
    }
  }
  
  console.log('✅ Access granted');
  return children;
};

/**
 * AdminRoute - Wrapper para rutas de administrador
 * Verifica tipoUsuario === 2 (admin con usuario alfanumérico)
 */
export const AdminRoute = ({ children }) => {
  return (
    <PrivateRoute allowedRoles={[2]} checkTipoUsuario={true}>
      {children}
    </PrivateRoute>
  );
};

/**
 * InspectorRoute - Wrapper para rutas de inspector
 */
export const InspectorRoute = ({ children }) => {
  return (
    <PrivateRoute allowedRoles={[3, 5]}>
      {children}
    </PrivateRoute>
  );
};

export default PrivateRoute;
